export enum Endpoint {
  Profile = '/accounts/user/',
  ProfileEdit = '/accounts/profile/',
  ChangePassword = '/accounts/change/',
  ProfileEditAvatar = '/accounts/avatar/',
  Statistic = '/affiliate/statistic/',
  Referrals = '/affiliate/referrals/',
  AutoBonus = '/affiliate/autobonus/',
  Transactions = '/transactions/',
  TransactionsRates = '/transactions/rates/',
  Withdraw = '/transactions/withdrow/',
  Deposit = '/transactions/deposit/',
  Tickets = '/tickets/ticket/',
  TicketsDialog = '/tickets/dialog/',
  TicketsFiles = '/tickets/files/',
  StatusStatistic = '/affiliate/status/statistic/',
  StatusRank = '/affiliate/status/rank/',
  StatusReferrals = '/affiliate/status/referrals/',
  PoolList = '/affiliate/pools/',
  PoolStatistic = '/affiliate/pool/statistic',
  PoolUsers = '/affiliate/participants/',
  News = '/news/',
  Documents = '/documents/',
  Challenge = '/affiliate/cashback/challenge/',
  ClaimCashback = '/affiliate/cashback/claim/',

  ConnectUs = '/accounts/feedback/',
  Registration = '/accounts/register/',
  RegistrationActive = '/accounts/activate/',
  ResetPassword = '/accounts/reset/',
  SignIn = '/accounts/login/',
  SignOut = '/accounts/logout/',
  Refresh = '/accounts/refresh/',

  Verification = '/verification/access-token/',

  country = 'https://restcountries.com/v3.1/all',
}
